import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class UserTelegramDto
*  Данные привязки телеграм для текущей витрины<br>
*/
export class UserTelegramDto extends ActiveModel {

  /**
  * userId
  * Идентификатор пользователя в телеграм. <br>null, если аккаунт телеграм не привязан<br>  */
  @ActiveField()
  userId?: null | number


/**
  * userName
  * Имя пользователя в телеграм. Может быть пустым, даже при наличии Web.Core.Shared.UserTelegramDto.UserId
  */
  @ActiveField()
  userName?: null | string


  /**
  * chatId
  * Идентификатор чата с пользователем. <br>null, если аккаунт телеграм не привязан<br>  */
  @ActiveField()
  chatId?: null | number


  /**
  * isAwaitingBind
  * true, если выдан ещё не истёкший ключ привязки и ожидается `/start`  */
  @ActiveField()
  isAwaitingBind?: boolean
}
